// ONBOARDING MEMORY — lightweight, per browser (localStorage), SEPARATE from every pedagogical / developmental record. Nothing here is evidence.
export const MEMORY_KEY = "tws_onboarding_v1";
export const MEMORY_EVENT = "tws-onboarding-memory";
export const DEFAULT_MEMORY = {
  guidanceEnabled: true,   // the GLOBAL switch above every once-only flag: automatic guidance on/off (manual help always works)
  initialTourSeen: false, initialTourCompleted: false,
  strengthenTourSeen: false, strengthenTourCompleted: false,
  studentStartTourSeen: false, studentStartTourCompleted: false,
  teacherTourSeen: false, teacherTourCompleted: false,
  structureIntroSeen: false, bigPictureIntroSeen: false,
  consolidateIntroSeen: false, sentenceIntroSeen: false, proofreadIntroSeen: false,
  imLostIntroSeen: false,
  dynamicProcessIntroSeen: false,
  essayOrientationSeen: false,
};
export function readMemory() {
  try { return { ...DEFAULT_MEMORY, ...(JSON.parse(localStorage.getItem(MEMORY_KEY) || "{}") || {}) }; } catch { return { ...DEFAULT_MEMORY }; }
}
export function writeMemory(patch) {
  const next = { ...readMemory(), ...patch };
  try { localStorage.setItem(MEMORY_KEY, JSON.stringify(next)); } catch { /* memory only */ }
  try { window.dispatchEvent(new CustomEvent(MEMORY_EVENT)); } catch { /* ignore */ }
  return next;
}
export function resetMemory() {
  try { localStorage.removeItem(MEMORY_KEY); } catch { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent(MEMORY_EVENT)); } catch { /* ignore */ }
  return { ...DEFAULT_MEMORY };
}
